"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAllExtensionsServices = registerAllExtensionsServices;
exports.registerInitializationExtensionsServices = registerInitializationExtensionsServices;
const api_shared_js_1 = require("@tableau/api-shared-js");
const InitializationServiceImpl_1 = require("./Impl/InitializationServiceImpl");
const SettingsServiceImpl_1 = require("./Impl/SettingsServiceImpl");
const UIServiceImpl_1 = require("./Impl/UIServiceImpl");
const ServiceRegistryUtil_1 = require("./ServiceRegistryUtil");
function registerAllExtensionsServices(dispatcher) {
    api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).registerService(new SettingsServiceImpl_1.SettingsServiceImpl(dispatcher, ServiceRegistryUtil_1.ExtensionsRegistryId));
    api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).registerService(new UIServiceImpl_1.UIServiceImpl(dispatcher, ServiceRegistryUtil_1.ExtensionsRegistryId));
}
function registerInitializationExtensionsServices(dispatcher) {
    api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).registerService(new InitializationServiceImpl_1.InitializationServiceImpl(dispatcher, ServiceRegistryUtil_1.ExtensionsRegistryId));
}
//# sourceMappingURL=RegisterAllExtensionsServices.js.map